export default __webpack_public_path__ + "static/media/04.97421dc0.png";